import inputTypes from "../../../../formComponents/formFields/constants";

const formFields = {
  email: {
    default: undefined,
    type: inputTypes.SIMPLE_TEXT,
    required: true,
    label: "Recipient email",
  },
  amount: {
    default: undefined,
    type: inputTypes.NUMBER,
    required: true,
    label: "Amount",
    minValue: 1,
  },
  campaign_type: {
    default: undefined,
    type: inputTypes.SELECT,
    required: false,
    options: [
      {
        label: "Prepayment for a Challenge",
        value: "Prepayment for a Challenge",
      },
    ],
  },
};

const inputsConfigWithNames = Object.fromEntries(
  Object.entries(formFields).map(([fKey, fVal]) => [
    fKey,
    { name: fKey, ...fVal },
  ]),
);

export default inputsConfigWithNames;
